var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTykhereLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tykhere_Logo_H",
    xmlns: "http://www.w3.org/2000/svg",
    width: 175,
    height: 61.623,
    viewBox: "0 0 175 61.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2917",
    "data-name": "Group 2917",
    transform: "translate(75.309 17.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2916",
    "data-name": "Group 2916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2914",
    "data-name": "Group 2914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17621",
    "data-name": "Path 17621",
    d: "M382.448,147.615a1.606,1.606,0,0,1-1.659,1.578,6.433,6.433,0,0,1-.718-.027,4.078,4.078,0,0,1-2.433-1.184,3.779,3.779,0,0,1-.94-2.369v-6.634h-1.19a1.581,1.581,0,1,1,0-3.159h1.19v-5.029a1.66,1.66,0,0,1,3.317,0v5.029h.911a1.581,1.581,0,1,1,0,3.159h-.911v6.264c.056.212,0,.525.193.686.139.131.386.1.581.1A1.629,1.629,0,0,1,382.448,147.615Z",
    transform: "translate(-373.85 -129.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17622",
    "data-name": "Path 17622",
    d: "M428.971,156.748v11.505a6.817,6.817,0,0,1-11.937,4.343,1.578,1.578,0,0,1,.166-2.237,1.6,1.6,0,0,1,2.267.185,3.681,3.681,0,0,0,2.709,1.211,3.546,3.546,0,0,0,3.564-3.5v-1.08a6.549,6.549,0,0,1-3.151.817,6.409,6.409,0,0,1-6.329-6.476V156.8a1.6,1.6,0,0,1,3.2,0v4.713a3.142,3.142,0,1,0,6.275,0v-4.764a1.616,1.616,0,0,1,3.231,0Z",
    transform: "translate(-404.897 -148.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17623",
    "data-name": "Path 17623",
    d: "M487.975,149.241a1.854,1.854,0,0,1-1.243.5,1.679,1.679,0,0,1-1.133-.421l-5.637-4.949V148.3a1.687,1.687,0,0,1-3.371,0v-16.77a1.687,1.687,0,0,1,3.371,0v8.9l5.445-3.58a1.736,1.736,0,0,1,2.35.394,1.557,1.557,0,0,1-.386,2.237l-4.614,2.974,5.139,4.5A1.592,1.592,0,0,1,487.975,149.241Z",
    transform: "translate(-449.062 -129.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17624",
    "data-name": "Path 17624",
    d: "M541.4,148.219a1.675,1.675,0,0,1-3.344,0v-5.766a2.849,2.849,0,0,0-5.691,0v5.766a1.633,1.633,0,0,1-1.685,1.581,1.65,1.65,0,0,1-1.685-1.581V131.425a1.672,1.672,0,0,1,1.685-1.6,1.652,1.652,0,0,1,1.685,1.6v5.79a6.449,6.449,0,0,1,2.846-.659,6.039,6.039,0,0,1,6.189,5.9Z",
    transform: "translate(-487.422 -129.657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17625",
    "data-name": "Path 17625",
    d: "M597.534,162.492h-8.51a3.606,3.606,0,0,0,3.51,2.658,4.779,4.779,0,0,0,2.9-1,1.719,1.719,0,0,1,2.35.027,1.507,1.507,0,0,1-.027,2.237,7.92,7.92,0,0,1-5.222,1.87,6.614,6.614,0,1,1,0-13.215,6.433,6.433,0,0,1,1.216.1,6.688,6.688,0,0,1,4.477,3.028,4.921,4.921,0,0,1,.884,2.58,2.155,2.155,0,0,1-.22.764A1.513,1.513,0,0,1,597.534,162.492Zm-8.041-2.658h5.86a3.1,3.1,0,0,0-2.819-1.581A3.641,3.641,0,0,0,589.494,159.834Z",
    transform: "translate(-528.886 -148.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17626",
    "data-name": "Path 17626",
    d: "M657.117,158.817a1.719,1.719,0,0,1-2.35.078,3.437,3.437,0,0,0-5.72,2.527V166.4a1.66,1.66,0,0,1-3.317,0V156.314a1.6,1.6,0,0,1,1.659-1.554,1.64,1.64,0,0,1,1.575,1.08,6.925,6.925,0,0,1,3.51-.975,6.847,6.847,0,0,1,4.56,1.736A1.5,1.5,0,0,1,657.117,158.817Z",
    transform: "translate(-572.883 -147.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17627",
    "data-name": "Path 17627",
    d: "M707.477,162.492h-8.512a3.606,3.606,0,0,0,3.51,2.658,4.779,4.779,0,0,0,2.9-1,1.719,1.719,0,0,1,2.35.027,1.507,1.507,0,0,1-.027,2.237,7.92,7.92,0,0,1-5.222,1.87,6.614,6.614,0,1,1,0-13.215,6.432,6.432,0,0,1,1.216.1,6.688,6.688,0,0,1,4.477,3.028,4.921,4.921,0,0,1,.884,2.58,2.155,2.155,0,0,1-.22.764A1.506,1.506,0,0,1,707.477,162.492Zm-8.041-2.658h5.86a3.1,3.1,0,0,0-2.819-1.581A3.641,3.641,0,0,0,699.436,159.834Z",
    transform: "translate(-609.369 -148.141)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2915",
    "data-name": "Group 2915",
    transform: "translate(0.185 29.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17628",
    "data-name": "Path 17628",
    d: "M376.965,239.617a.326.326,0,0,1-.051.2.187.187,0,0,1-.155.064h-.715v2.9h-.6v-2.9h-.9v-.445h2.4A1.036,1.036,0,0,1,376.965,239.617Z",
    transform: "translate(-374.54 -239.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17629",
    "data-name": "Path 17629",
    d: "M396.435,242.347a.754.754,0,0,1-.054.343.2.2,0,0,1-.2.091H394.34V239.44H396.4v.434h-1.455v.973h1.227v.429h-1.227v1.069h1.492Z",
    transform: "translate(-389.035 -239.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17630",
    "data-name": "Path 17630",
    d: "M414.087,242.6a.966.966,0,0,1-.434-.265.58.58,0,0,1-.153-.4.268.268,0,0,1,.118-.23.593.593,0,0,1,.327-.086.676.676,0,0,0,.252.458.886.886,0,0,0,.555.161.846.846,0,0,0,.509-.134.444.444,0,0,0,.18-.38.387.387,0,0,0-.174-.327,2,2,0,0,0-.614-.247,2.094,2.094,0,0,1-.836-.391.766.766,0,0,1-.252-.6.787.787,0,0,1,.322-.667,1.444,1.444,0,0,1,.884-.244,1.365,1.365,0,0,1,.79.22,1.118,1.118,0,0,1,.442.611.647.647,0,0,1-.383.158.209.209,0,0,1-.129-.035.394.394,0,0,1-.1-.121.646.646,0,0,0-.624-.386c-.4,0-.6.139-.6.421a.422.422,0,0,0,.056.228.491.491,0,0,0,.2.161,3.13,3.13,0,0,0,.421.158,4.745,4.745,0,0,1,.745.284.969.969,0,0,1,.359.287.7.7,0,0,1,.1.394.953.953,0,0,1-.163.555,1.056,1.056,0,0,1-.461.375,1.7,1.7,0,0,1-.694.134A2.179,2.179,0,0,1,414.087,242.6Z",
    transform: "translate(-403.061 -239.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17631",
    "data-name": "Path 17631",
    d: "M435.655,239.617a.325.325,0,0,1-.051.2.187.187,0,0,1-.155.064h-.715v2.9h-.6v-2.9h-.9v-.445h2.4A.822.822,0,0,1,435.655,239.617Z",
    transform: "translate(-417.505 -239.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17632",
    "data-name": "Path 17632",
    d: "M468.51,239.44l-1.045,1.937v1.4h-.6v-1.4l-1.045-1.937h.63l.721,1.4.715-1.4Z",
    transform: "translate(-441.363 -239.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17633",
    "data-name": "Path 17633",
    d: "M486.455,242.249a1.967,1.967,0,0,1-.375-1.281,1.888,1.888,0,0,1,.375-1.254,1.469,1.469,0,0,1,2.106,0,1.888,1.888,0,0,1,.375,1.254,1.967,1.967,0,0,1-.375,1.281,1.445,1.445,0,0,1-2.106,0Zm1.661-.311a1.867,1.867,0,0,0,.2-.97,1.773,1.773,0,0,0-.2-.946.772.772,0,0,0-1.222,0,1.766,1.766,0,0,0-.2.946,1.854,1.854,0,0,0,.2.97.747.747,0,0,0,1.216,0Z",
    transform: "translate(-456.194 -239.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17634",
    "data-name": "Path 17634",
    d: "M508.13,241.583V239.44h.606v2.229a.722.722,0,0,0,.182.533.737.737,0,0,0,.533.179.722.722,0,0,0,.536-.177.734.734,0,0,0,.174-.533v-2.229h.606v2.144a1.232,1.232,0,0,1-.324.94,1.4,1.4,0,0,1-.991.305Q508.129,242.828,508.13,241.583Z",
    transform: "translate(-472.336 -239.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17635",
    "data-name": "Path 17635",
    d: "M532.541,242.726a.416.416,0,0,1-.142.062.826.826,0,0,1-.2.024.469.469,0,0,1-.214-.04.261.261,0,0,1-.118-.137l-.421-.839a.612.612,0,0,0-.206-.252.642.642,0,0,0-.33-.07h-.273v1.3h-.606V239.43h1.12a1.5,1.5,0,0,1,.954.268.906.906,0,0,1,.338.753.9.9,0,0,1-.174.555.992.992,0,0,1-.493.34,1.248,1.248,0,0,1,.22.311Zm-1.431-1.693a.869.869,0,0,0,.544-.139.523.523,0,0,0,.177-.437.529.529,0,0,0-.171-.437.847.847,0,0,0-.539-.142h-.482v1.155Z",
    transform: "translate(-488.368 -239.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17636",
    "data-name": "Path 17636",
    d: "M567.292,242.77a.91.91,0,0,1-.386.062.462.462,0,0,1-.2-.035.287.287,0,0,1-.121-.113l-.664-1.077a1.221,1.221,0,0,0-.139-.193.29.29,0,0,0-.142-.08,1,1,0,0,0-.23-.021h-.086v1.479h-.606V239.45h.606v1.436h.281l.991-1.436h.654l-1.131,1.589a1.321,1.321,0,0,1,.359.4Z",
    transform: "translate(-513.763 -239.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17637",
    "data-name": "Path 17637",
    d: "M587.825,242.468c.005.088.011.147.011.177,0,.086-.04.129-.123.129h-.49v-.2a1.021,1.021,0,0,0-.185-.531l-1.23-1.779v2.505h-.6v-3.341h.531a.256.256,0,0,1,.1.016.214.214,0,0,1,.08.078l1.3,1.87V239.43h.6v2.687C587.817,242.219,587.82,242.334,587.825,242.468Z",
    transform: "translate(-528.763 -239.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17638",
    "data-name": "Path 17638",
    d: "M606.675,242.249a1.967,1.967,0,0,1-.375-1.281,1.889,1.889,0,0,1,.375-1.254,1.469,1.469,0,0,1,2.106,0,1.888,1.888,0,0,1,.375,1.254,1.967,1.967,0,0,1-.375,1.281,1.445,1.445,0,0,1-2.106,0Zm1.659-.311a1.868,1.868,0,0,0,.2-.97,1.773,1.773,0,0,0-.2-.946.772.772,0,0,0-1.222,0,1.767,1.767,0,0,0-.2.946,1.854,1.854,0,0,0,.2.97.747.747,0,0,0,1.216,0Z",
    transform: "translate(-544.203 -239.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17639",
    "data-name": "Path 17639",
    d: "M631.27,239.44a14.076,14.076,0,0,1-.774,3.341h-.643q-.261-.824-.386-1.278c-.083-.3-.153-.614-.209-.93-.064.354-.139.689-.225,1.007s-.209.718-.367,1.2h-.643a14.952,14.952,0,0,1-.509-1.621,15.676,15.676,0,0,1-.314-1.717h.6c.064.565.134,1.034.206,1.4s.188.8.338,1.286c.131-.394.238-.766.327-1.112s.206-.873.356-1.578h.453q.285,1.222.407,1.7t.289.989a12.633,12.633,0,0,0,.319-1.265c.07-.37.134-.844.2-1.423h.581Z",
    transform: "translate(-559.503 -239.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17640",
    "data-name": "Path 17640",
    d: "M655.417,242.347v.434H653.45V239.44h.606v2.907Z",
    transform: "translate(-578.719 -239.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17641",
    "data-name": "Path 17641",
    d: "M673.705,242.347a.753.753,0,0,1-.054.343.2.2,0,0,1-.2.091H671.61V239.44h2.058v.434h-1.455v.973h1.227v.429h-1.227v1.069h1.492Z",
    transform: "translate(-592.014 -239.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17642",
    "data-name": "Path 17642",
    d: "M693.116,239.872a1.7,1.7,0,0,1,.423,1.23,1.868,1.868,0,0,1-.2.882,1.4,1.4,0,0,1-.555.581,1.687,1.687,0,0,1-.847.206H690.86V239.43h1.082A1.57,1.57,0,0,1,693.116,239.872Zm-.458,2.152a1.363,1.363,0,0,0,.273-.914q0-1.242-1.058-1.241h-.415v2.47h.415A.989.989,0,0,0,692.658,242.024Z",
    transform: "translate(-606.106 -239.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17643",
    "data-name": "Path 17643",
    d: "M714.587,240.835V242.3a1.325,1.325,0,0,1-.5.295,2.055,2.055,0,0,1-.662.1,1.484,1.484,0,0,1-1.157-.434,1.854,1.854,0,0,1-.394-1.283,2.063,2.063,0,0,1,.19-.916,1.39,1.39,0,0,1,.549-.595,1.642,1.642,0,0,1,.844-.206,1.978,1.978,0,0,1,.646.1,1.123,1.123,0,0,1,.469.287.718.718,0,0,1-.131.233c-.059.07-.11.1-.155.1a.27.27,0,0,1-.142-.054,1.078,1.078,0,0,0-.329-.171,1.227,1.227,0,0,0-.367-.054.829.829,0,0,0-.71.324,1.55,1.55,0,0,0-.244.946q0,1.27.927,1.27a1.325,1.325,0,0,0,.338-.04.59.59,0,0,0,.233-.107v-.831h-.421a.192.192,0,0,1-.185-.1.765.765,0,0,1-.054-.338h1.259Z",
    transform: "translate(-621.487 -239.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17644",
    "data-name": "Path 17644",
    d: "M735.645,242.347a.754.754,0,0,1-.054.343.2.2,0,0,1-.2.091H733.55V239.44h2.058v.434h-1.455v.973h1.227v.429h-1.227v1.069h1.492Z",
    transform: "translate(-637.358 -239.389)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2926",
    "data-name": "Group 2926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2918",
    "data-name": "Group 2918",
    transform: "translate(30.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17645",
    "data-name": "Path 17645",
    d: "M221.464,64.926,208.1,72.642l-2.036,1.176,2.036,1.176,11.331,6.543,2.036-1.176,13.705-7.912L221.8,64.73Z",
    transform: "translate(-206.06 -64.73)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2919",
    "data-name": "Group 2919",
    transform: "translate(29.594 8.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17646",
    "data-name": "Path 17646",
    d: "M203.23,97.88l2.125,1.219,11.851,6.792,2.1-1.211Z",
    transform: "translate(-203.23 -97.88)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2920",
    "data-name": "Group 2920",
    transform: "translate(1.246 0.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17647",
    "data-name": "Path 17647",
    d: "M126.536,76.227,124.5,75.051l-10.854-6.267a5.693,5.693,0,0,0-5.7,0L97.43,74.858l13.7,7.91,2.036,1.176,11.331,6.54,2.036,1.176,2.036-1.176L139.9,83.941,128.572,77.4Z",
    transform: "translate(-97.43 -68.02)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2921",
    "data-name": "Group 2921",
    transform: "translate(32.313 35.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17648",
    "data-name": "Path 17648",
    d: "M226.777,216.056l.062-15.433.008-2.352-2.042,1.168-11.355,6.5-.008,2.352-.062,15.824,13.4-7.666Z",
    transform: "translate(-213.38 -198.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2922",
    "data-name": "Group 2922",
    transform: "translate(32.372 35.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17649",
    "data-name": "Path 17649",
    d: "M227.568,196.22l-2.122,1.222-11.835,6.822-.011,2.422Z",
    transform: "translate(-213.6 -196.22)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17650",
    "data-name": "Path 17650",
    d: "M227.044,131.44l2.042-1.168,10.878-6.224a5.7,5.7,0,0,0,2.867-4.922l.048-12.146-13.732,7.859-2.042,1.168-11.355,6.5-2.042,1.168-.008,2.353-.051,13.083,11.355-6.5Z",
    transform: "translate(-181.264 -95.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2923",
    "data-name": "Group 2923",
    transform: "translate(15.835 35.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17651",
    "data-name": "Path 17651",
    d: "M151.947,216.056l-.059-15.433-.008-2.352,2.039,1.168,11.358,6.5.008,2.352.062,15.824-13.4-7.666Z",
    transform: "translate(-151.88 -198.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2924",
    "data-name": "Group 2924",
    transform: "translate(15.275 35.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17652",
    "data-name": "Path 17652",
    d: "M149.79,196.22l2.122,1.222,11.832,6.822.011,2.422Z",
    transform: "translate(-149.79 -196.22)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2925",
    "data-name": "Group 2925",
    transform: "translate(0 11.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17653",
    "data-name": "Path 17653",
    d: "M108.615,131.44l-2.042-1.168L95.7,124.048a5.7,5.7,0,0,1-2.867-4.922L92.78,106.98l13.732,7.859,2.042,1.168,11.355,6.5,2.042,1.168.008,2.353.051,13.083-11.355-6.5Z",
    transform: "translate(-92.78 -106.98)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTykhereLogoWhite);
export default __webpack_public_path__ + "static/media/tykhere-logo-white.ff50b4c55fa767f8f3fdb67fb67f34ad.svg";
export { ForwardRef as ReactComponent };